import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import Content from 'components/Content';
import RedirectToCheckoutHandler from 'components/RedirectToCheckoutHandler';
import infoIcoDoodly from 'images/info-ico-doodly.png';
import { withRouter } from 'react-router';

import { SsoButton } from '@voomly_llc/umbrella-interapp-lib/react';
import { asyncLoginViaSsoApp } from 'actions/sso-app';

import './Login.scss';
const fbq = window.fbq;

export class Login extends Component {
  queryParams = new URLSearchParams(window.location.search);
  redirectUrl = this.queryParams.get('redirect_url');

  componentDidMount() {
    document.title = 'Doodly: Login';
    fbq('track', 'PageView');

    if (!this.props.isAuthenticated && this.redirectUrl) {
      this.loginViaSso();
    }
  }

  loginViaSso = () => {
    this.props.loginViaSso();
  };

  render() {
    const { isAuthenticated, redirectTo } = this.props;

    if (isAuthenticated && this.props.userEmail) {
      if (this.redirectUrl) {
        return <RedirectToCheckoutHandler to={`${this.redirectUrl}&email=${this.props.userEmail}`} />;
      } else {
        return <Redirect to={redirectTo || '/'} />;
      }
    }

    return (
      <div className="login d-flex flex-column">
        <Header />
        <Content>
          <div className="container">
            <div className="row mt-4 mb-5 justify-content-around">
              <div className="sheet login-form col-lg-8">
                <h1 className="text-center mb-4">Login</h1>
                <div className="info mb-5">
                  <div className="d-flex align-items-start">
                    <img src={infoIcoDoodly} alt="Doodly" className="mr-4 d-none d-md-inline" />
                    <span>
                      <b>If you own Doodly, your marketplace account has already been created for you</b>, so you can
                      login below using your Doodly login and the images will be automatically added to the Marketplace
                      tab inside of your Doodly software.
                    </span>
                  </div>
                </div>

                <div className="mb-5 text-center">
                  <SsoButton onClick={this.loginViaSso} disabled={this.props.ssoApp.loginIViaSsoInProgress}>
                    Login via Voomly Cloud
                  </SsoButton>
                </div>

                {this.props.ssoApp.loginViaSsoError && (
                  <div className="mb-5 text-center">{this.props.ssoApp.loginViaSsoError}</div>
                )}

                <div className="text-center mb-4">
                  <a href="https://cloud.voomly.com">Get Voomly Cloud</a>
                </div>
                {/* <LoginForm className="" /> */}
              </div>
            </div>
          </div>
        </Content>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  redirectTo: state.auth.redirectTo,
  ssoApp: state.ssoApp,
  userEmail: state.user?.email || state.ssoApp.data?.email
});

const mapDispatchToProps = dispatch => ({
  loginViaSso: () => dispatch(asyncLoginViaSsoApp())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
